import { useCallback } from "react"

import type { ApAgingInvoiceSort } from "../types/apAgingReport"
import type { ApAgingReportSearchParams } from "../types/searchParams"
import { getApAgingExportFileName, toApAgingExportUrl } from "../utils"

import { useFileDownload } from "@/hooks/useFileDownload"
import { useAuthStore } from "@/stores/authStore"
import { getApiOrigin } from "@/utils/getApiOrigin"

interface UseExportApAgingReportReturn {
  exportApAgingReport: (searchParams: ApAgingReportSearchParams, invoiceSort: ApAgingInvoiceSort) => Promise<boolean>
  isExporting: boolean
}

export const useExportApAgingReport = (): UseExportApAgingReportReturn => {
  const { downloadFile, isLoading } = useFileDownload()

  const exportApAgingReport = useCallback(
    async (searchParams: ApAgingReportSearchParams, invoiceSort: ApAgingInvoiceSort): Promise<boolean> => {
      const accessToken = useAuthStore.getState().tokens.accessToken
      const baseUrl = getApiOrigin().replace("/graphql", "")

      return downloadFile(toApAgingExportUrl(baseUrl, searchParams, invoiceSort), getApAgingExportFileName(), {
        Authorization: `Bearer ${accessToken}`,
      })
    },
    [downloadFile]
  )

  return { exportApAgingReport, isExporting: isLoading }
}
